export default __webpack_public_path__ + "static/media/107.8803265b.png";